import React, { FC, useState } from 'react'
import first from 'lodash/first'
import last from 'lodash/last'
import { ApolloDayPicker } from '@ui'
import css from './bookingDayPicker.module.scss'
import { DateUtil } from '@utils/dateUtil'
import { DateFormatter } from 'react-day-picker'
import { format } from 'date-fns'
import { UseFloorHook } from '@providers/mapProvider'

type BookingCalendarPropsT = {
  isRecurrence: boolean
  numOfViews?: number
  timezone: string
  constraints: { first: DateUtil; last: DateUtil }
  onDayClick: (date: DateUtil) => void
  selected: DateUtil[]
  headerRender?: JSX.Element
  floor: UseFloorHook
}

export enum DayPickerModes {
  MULTIPLE = 'multiple',
  RANGE = 'range',
  SINGLE = 'single',
}

export type SelectedMapT = {
  [DayPickerModes.MULTIPLE]: Date[]
  [DayPickerModes.RANGE]: {
    from: Date
    to?: Date
  }
  [DayPickerModes.SINGLE]: Date | undefined
}

const BookingDayPicker: FC<BookingCalendarPropsT> = ({
  selected,
  numOfViews,
  timezone,
  onDayClick,
  constraints,
  isRecurrence,
  headerRender,
  floor,
}) => {
  const currentDate = DateUtil.tz(timezone)
  const firstDate = first(selected)
  const lastDate = last(selected) as DateUtil

  const mode = floor?.isBookMeetingRoomPage
    ? DayPickerModes.SINGLE
    : isRecurrence
    ? DayPickerModes.MULTIPLE
    : DayPickerModes.RANGE

  const selectedMap: SelectedMapT = {
    [DayPickerModes.MULTIPLE]: selected.map((d) => d.toDate()),
    [DayPickerModes.RANGE]: {
      from: (firstDate || currentDate).toDate(),
      to: !firstDate?.isSame(lastDate) ? lastDate?.toDate() : undefined,
    },
    [DayPickerModes.SINGLE]: firstDate?.toDate(),
  }

  const disabledDays = {
    before: constraints.first.toDate(),
    after: constraints.last.toDate(),
  }
  const formatWeekdayName: DateFormatter = (day) => {
    return format(day, 'EEEEE')
  }

  return (
    <div className={css.wrapper}>
      {headerRender}
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <ApolloDayPicker
        mode={mode}
        defaultMonth={currentDate.toDate()}
        numberOfMonths={numOfViews}
        selected={selectedMap[mode]}
        modifiers={{
          start: firstDate ? firstDate.tz(timezone).toDate() : currentDate.toDate(),
        }}
        formatters={{ formatWeekdayName }}
        disabled={disabledDays}
        onDayClick={(date) => onDayClick(DateUtil.tz(timezone).setDate(date))}
      />
    </div>
  )
}

export default BookingDayPicker
